/** Trending GIF results, shared across picker instances (which remount on every open) so
 * reopening the picker or clearing the search doesn't wait on a network round-trip. */
export const trendingGifCache = { data: null };
